import request_api from "../../core/request_api";
import Swal from "sweetalert2";

const state = {
  dataContactUs: [],
};
const getters = {
  getdataContactUs(state) {
    return state.dataContactUs;
  },
};
const mutations = {
  CONTACT_START(state, payload) {
    return (state.dataContactUs = payload);
  },
};
const actions = {
  contactUsStart({ commit }, data_contact) {
    // console.log(data_contact);
    const tempData = {
      name: data_contact.name,
      email: data_contact.email,
      message: data_contact.message,
    };
    request_api()
      .post("master/about-us/create", tempData)
      .then((res) => {
        const meta = res.data;
        if (meta.code === 200) {
          commit("CONTACT_START", res.data);
          Swal.fire({
            icon: "success",
            title: "Good Job!",
            text: meta.message,
          });
        }
      })
      .catch((err) => {
        // console.log(err)
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: err.response.data.message,
        });
      });
  },
};
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
